/* eslint-disable*/
import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AiFillPrinter } from "react-icons/ai";
import { IoMailOutline } from "react-icons/io5";
import { IoMdArrowBack } from "react-icons/io";
import BookingModal from "./BookingModal";

import BtnModalExpenses from "./Booking/BtnModalExpenses";
import PinIconModal from "./PinIconModal";
import DeleteModal from "./DeleteModal";
import moment from "moment";
import { axiosInstanceWithToken } from "../helpers/axios";
import BookingDetailsTabs from "./Details/BookingDetailsTabs";
import { fDateMoment } from "@/utils/formatDate";

const MyTripR = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { row, isHost = false } = location.state;
  const [loading, setLoading] = useState(true);
  const [booking, setBooking] = useState();

  useEffect(() => {
    axiosInstanceWithToken.get(`/trip/${row.id}`).then(({ data }) => {
      setBooking({
        ...data?.data,
        meta_data:
          typeof data?.data?.meta_data === "string"
            ? JSON.parse(data?.data?.meta_data)
            : data?.data?.meta_data,
      });
      setLoading(false);
    });
  }, [row]);

  const isConfirm = booking?.status === "pending_approval";

  const arriveDate = moment(booking?.arrival_date); // Ensure this is a Moment object
  const departDate = moment(booking?.departure_date); // Ensure this is a Moment object

  const arrival = fDateMoment(booking?.arrival_date); // "Apr 08 2025"
  const departure = fDateMoment(booking?.departure_date); // Formatted output

  // Now you can safely clone and use diff
  const diffDays = departDate.diff(arriveDate, "days"); // Calculate difference in days

  console.log({ diffDays });

  // Check if any date in the range is a weekend (Saturday or Sunday)
  let hasWeekend = false;
  const weekendDays = []; // To store weekend dates if needed

  let currentDate = moment(booking?.arrival_date).clone(); // Clone the Moment.js object

  while (currentDate.isSameOrBefore(departDate)) {
    const dayOfWeek = currentDate.day(); // 0 = Sunday, 6 = Saturday
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      hasWeekend = true;
      weekendDays.push(currentDate.clone().format("MMM DD YYYY")); // Store formatted date
    }
    currentDate.add(1, "days"); // Move to the next day
  }

  function PrintElem() {
    var elemContent = document.getElementById("elem").innerHTML;
    var mywindow = window.open("", "PRINT", "height=400,width=600");

    mywindow.document.write("<html><head>");
    mywindow.document.write("</head><body>");
    mywindow.document.write(elemContent);
    mywindow.document.write("</body></html>");

    mywindow.document.close();

    // Wait for the content to load
    mywindow.onload = function () {
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    };

    return true;
  }

  const [isOpen, setIsOpen] = useState(false);
  const [expenses, setExpenses] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [push, setPush] = useState(false);

  const handleConfirmBooking = useCallback((status) => {
    let data = new FormData();
    data.append("_method", "PATCH");
    data.append("is_approved", status);
    axiosInstanceWithToken
      .post(`/trip/${row?.id}`, data)
      .then((response) => {
        if (response.status === 200) {
          navigate("/trip", { replace: true });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-5">
        <img
          className="h-auto w-36 md:w-44" // Responsive sizes
          src="/image/fly-inn-logo.svg"
          alt="Fly Inn Logo"
        />
        <div className="text-2xl text-bold">
          {" "}
          Please Wait while we load your data!
        </div>
      </div>
    );
  }

  return (
    <>
      {expenses && (
        <BtnModalExpenses
          expenseList={expenseList}
          setExpenseList={setExpenseList}
          expenses={expenses}
          setExpenses={setExpenses}
        />
      )}
      {openDelete && (
        <DeleteModal openDelete={openDelete} setOpenDelete={setOpenDelete} />
      )}

      <main className="col-md-12" style={{ marginTop: "30px" }}>
        <div className="flex col-md-12">
          <div
            className="col-md-12"
            style={{ paddingBottom: "20px" }}
            id="elem"
          >
            <div style={{ padding: "16px" }}>
              <h1> Booking Details</h1>
              <div className="flex justify-end w-full gap-2 p-6 bg-white">
                <div className="p-2 text-white bg-gray-400 rounded-md shadow-md icon_button_booking">
                  <AiFillPrinter
                    style={{ cursor: "pointer" }}
                    onClick={PrintElem}
                    size={20}
                  />
                </div>
                <Link
                  to={"/air_mail"}
                  className="p-2 text-white bg-gray-400 rounded-md shadow-md icon_button_booking"
                >
                  <IoMailOutline style={{ cursor: "pointer" }} size={20} />
                </Link>
                <div className="p-2 text-white bg-gray-400 rounded-md shadow-md icon_button_booking">
                  <IoMdArrowBack
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(-1)}
                    size={20}
                  />
                </div>
              </div>

              <BookingDetailsTabs
                booking={booking}
                arrival={arrival}
                departure={departure}
                diffDays={diffDays}
                isConfirm={isConfirm}
                isHost={isHost}
                handleConfirmBooking={handleConfirmBooking}
              />
            </div>
          </div>
        </div>
      </main>
      {isOpen && <BookingModal isOpen={isOpen} setIsOpen={setIsOpen} />}
      {push && <PinIconModal push={push} setPush={setPush} />}
    </>
  );
};

export default MyTripR;
